export default interface AddToListProps {
    onChange: (existing, listName) => void;
    isContactsOptions?: boolean;
    isNewList?: boolean;
    moveContacts?: boolean;
    onChangeContactsType?: (contactsType: ContactsType) => void;
}

export enum ContactsType {
    Openers = 'openers',
    Nonopeners = 'nonopeners',
    Clickers = 'clickers',
    OpenedNotClicked = 'openednotclicked',
}
